import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Tooltip,
    Typography,
    useTheme
} from "@mui/material";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {ContractDetailModalProps, ContractPaymentList, IBookingDetails, IInvoiceDetails} from "../ContractInterfaces";
import {useStatusValuesContract} from "../../../component/useStatusValuesContract";
import {useContractActions} from "../../../service/useContractActions";
import PaymentsHistoryTable from "../../../component/PaymentsHistoryTable";
import {useHasScope} from "../../../../../config/globalConfig";
import DaysAccordion from "../accordion/DaysAccordion";
import BookingAndRaDetails from "../../../component/BookingAndRaDetails";
import InvoiceDetails from "../../../component/InvoiceDetails";
import {InfoRounded} from "@mui/icons-material";
import BillingAddress from "../../../component/BillingAddress";
import {formatDate} from "../../../component/Utils";


const ContractDetailModal = ({open,handleClose,contract}:ContractDetailModalProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'contract'});

    const {globalData} = useContext(GlobalContext);

    const hasScope = useHasScope

    const {getPaymentsBySubscriptionId, getPanCard, getBillingAddress, getBookingDetailsBySubscriptionId, getInvoiceDetailsBySubscriptionId} = useContractActions()

    const [contractPaymentList,setContractPaymentList] = useState<ContractPaymentList[]>([]);
    const [bookingDetail, setBookingDetails] = useState<IBookingDetails[]>([]);
    const [invoiceDetail, setInvoiceDetails] = useState<IInvoiceDetails[]>([]);
    const [panCard, setPanCard] = useState<any>("");
    const [billingAddress, setBillingAddress] = useState<any>();
    const [openBillingAddress, setOpenBillingAddress] = useState(false);
    const {getStatusLabelContract} =  useStatusValuesContract()
    const theme = useTheme();
    useEffect(() => {
        if(contract.id){
            getPaymentsBySubscriptionId(contract.id).then(res => setContractPaymentList(res))
            getBookingDetailsBySubscriptionId(contract.id, contract.currentRate!).then(res => setBookingDetails(res))
            getInvoiceDetailsBySubscriptionId(contract.id, contract?.voucherCode, contract?.dealerId, contract?.tenantId).then(res => setInvoiceDetails(res))
        }
        if(contract?.paymentToolId) getPanCard(contract?.paymentToolId).then(res => setPanCard(res))
        if(contract?.bpCode) getBillingAddress(contract?.bpCode).then(res => setBillingAddress(res))
    }, []);

    return (
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('inputDetailPageFields.details') + ' ' + contract.id}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={()=> handleClose()}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container rowSpacing={3} columnSpacing={3}>
                    <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"} >
                        <Grid item>
                            <Button color={"accent"} style={{float:"right"}} onClick={() => {
                            window.open(`/finance/payments/payment-request?productType=SUBSCRIPTION&productId=${contract.id}`)
                            }}>
                            {t('payments')}
                            </Button>
                        </Grid>
                        <Grid item>
                            {hasScope('SCOPE_SM_REDIRECTING_FROM_SM_BOOKING_LIST') ? <Button color={"accent"} style={{float:"right"}} onClick={() => 
                            window.open(`/booking/list?subscriptionNumber=${contract.id}&customerAtDesk=false&hideDrafts=false&excludeSubStatuses=EXPIRED_DRAFT`)
                            }>
                            {t('inputUpdatePageFields.bookingList')}
                            </Button> : <></>}
                        </Grid>
                    </Grid>
                    {<UserLegalEntitiesOrDealersInputGroup tenantId={contract.tenantId} dealerId={contract?.dealerId} />}
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.status')}
                            value={getStatusLabelContract(contract.status.toUpperCase())}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.userLastModifiedBy')}
                            value={contract.userLastModifiedBy || '--'}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.note')}
                            value={contract.note}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.contractId')}
                            value={contract.id}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.voucherCode')}
                            value={contract.voucherCode}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.subscriptionPlanName')}
                            value={contract.subscriptionPlanName }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.creationDate')}
                            value={contract.creationDate ? formatDate(contract.creationDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.lastModifiedDate')}
                            value={contract.lastModifiedDate ?  formatDate(contract.lastModifiedDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.expirationDate')}
                            value={contract.expirationDate ? formatDate(contract.expirationDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.startDate')}
                            value={contract.startDate ? formatDate(contract.startDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.endDate')}
                            value={contract.actualExpirationDate ? formatDate(contract.actualExpirationDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.customerName')}
                            value={contract.customerName}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.vatCode')}
                            value={contract.vatCode}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.currentRate')}
                            value={contract.currentRate}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.panCard')}
                            value={panCard}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('inputDetailPageFields.bpCode')}
                            value={contract.bpCode}
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    {contract?.bpCode &&
                        <Grid item xs={3}>
                            <Tooltip title={t('billingAddress.billingAddress')} arrow>
                                    <span>
                                      <IconButton color="accent" onClick={() => {
                                          setOpenBillingAddress(true)
                                      }}>
                                            <InfoRounded/>
                                      </IconButton>
                                    </span>
                            </Tooltip>
                        </Grid>
                    }
                    {bookingDetail.length > 0 &&  <Grid item xs={12} sx={{marginTop:'50px'}}>
                        <BookingAndRaDetails data={bookingDetail}/>
                    </Grid>}
                    {invoiceDetail.length > 0 && <Grid item xs={12} sx={{marginTop:'10px'}}>
                        <InvoiceDetails data={invoiceDetail}/>
                    </Grid>}
                    {contractPaymentList.length > 0 && <Grid item xs={12} sx={{marginTop:'10px'}}>
                        <PaymentsHistoryTable data={contractPaymentList} showTyphography/>
                    </Grid>}
                    {contract.subscriptionPlanCategory ==='Car Box' &&
                        <Grid item xs={12} sx={{marginTop:'32px'}}>
                            <DaysAccordion used={contract.mobilityWalletCurrentCounter} total={contract.mobilityWalletTotalCounter} booked={contract.mobilityWalletBookedCounter}/>
                        </Grid>
                    }

                </Grid>
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => handleClose()}>{t('inputDetailPageFields.close')}</Button>
            </DialogActions>
            <BillingAddress billingAddress={billingAddress} open={openBillingAddress} bpCode={contract?.bpCode}
                            onClose={() => { setOpenBillingAddress(false);  }}/>

        </Dialog>
    )

}

export default ContractDetailModal;